import { z } from 'zod';
export type User = {
    email: string;
    firstName: string;
    middleName: string;
    lastName: string;
    password: string;
    pidm: number;
};

export const authCatalogEmailSchema = z.object({
    email: z.email({ error: 'iam:mailValidator' }).refine((email) => !email.endsWith('@bi.no'), {
        error: 'iam:binoMailForbidden',
    }),
});
export type AuthCatalogEmailForm = z.infer<typeof authCatalogEmailSchema>;

const passwordSchema = z
    .string()
    .min(12, { error: 'iam:newPasswordReq1' })
    .refine((password) => /[A-Z]/.test(password), {
        error: 'iam:newPasswordReq2a',
    })
    .refine((password) => /[a-z]/.test(password), {
        error: 'iam:newPasswordReq2a',
    })
    .refine((password) => /[0-9]/.test(password), { error: 'iam:newPasswordReq2b' })
    .refine((password) => /[!@#$%^&*]/.test(password), {
        error: 'iam:newPasswordReq2b',
    });

export const authCatalogUserSchema = z
    .object({
        email: z.email().optional(),
        pwd1: passwordSchema,
        pwd2: z.string().nonempty('common:required'),
    })
    .check((ctx) => {
        if (ctx.value.pwd1 !== ctx.value.pwd2) {
            ctx.issues.push({
                code: 'custom',
                error: 'iam:password2Validator',
                path: ['pwd2'],
                input: ctx.value.pwd2,
            });
        }
    });

export type AuthCatalogUserForm = z.infer<typeof authCatalogUserSchema>;
